module.exports = __webpack_public_path__ + "static/media/rococoLint_s.3456fbe5.jpg";